import React from 'react';
import { Link } from 'react-router-dom';
import { HELP_ARTICLES, getHelpArticlesBySection } from '../data/helpArticles';

export default function HelpManual() {
  const sections = getHelpArticlesBySection();

  return (
    <main className="sd-manual-page">
      <header className="sd-manual-hero">
        <div>
          <span>SEEDRONICS CLOUD</span>
          <h1>User Manual</h1>
          <p>Static help content for setup, operations, configuration, governance, and support workflows.</p>
        </div>
        <div className="sd-manual-actions">
          <button onClick={() => window.print()} type="button">Print / Save PDF</button>
          <Link to="/dashboard">Open Dashboard</Link>
        </div>
      </header>

      <section className="sd-manual-summary" aria-label="Manual summary">
        <div>
          <span>Articles</span>
          <strong>{HELP_ARTICLES.length}</strong>
        </div>
        <div>
          <span>Sections</span>
          <strong>{sections.length}</strong>
        </div>
        <div>
          <span>Format</span>
          <strong>Print-ready</strong>
        </div>
      </section>

      <nav className="sd-manual-toc" aria-label="Manual table of contents">
        {sections.map((section) => (
          <a href={`#${section.id}`} key={section.id}>{section.title}</a>
        ))}
      </nav>

      <div className="sd-manual-content">
        {sections.map((section) => (
          <section id={section.id} key={section.id}>
            <header>
              <span>{section.title}</span>
              <h2>{section.description}</h2>
            </header>
            {section.articles.map((article) => (
              <article className="sd-manual-article" key={article.id}>
                <h3>{article.title}</h3>
                <p className="sd-manual-summary-copy">{article.summary}</p>
                <p>{article.body}</p>
                <h4>Workflow</h4>
                <ol>
                  {article.steps.map((step) => <li key={step}>{step}</li>)}
                </ol>
                {article.tips && article.tips.length > 0 && (
                  <>
                    <h4>Notes</h4>
                    <ul>
                      {article.tips.map((tip) => <li key={tip}>{tip}</li>)}
                    </ul>
                  </>
                )}
                {article.relatedTabs && article.relatedTabs.length > 0 && (
                  <p className="sd-manual-related">Related: {article.relatedTabs.join(', ')}</p>
                )}
              </article>
            ))}
          </section>
        ))}
      </div>
    </main>
  );
}
